import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError, timeout } from 'rxjs/operators';
import { GrowlService } from '../service/growl.service';


@Injectable()
export class TimeoutInterceptor implements HttpInterceptor {

    constructor(private growlService: GrowlService) {
    }

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return next.handle(req)
            .pipe(
                timeout(30000),
                catchError(err => {
                    if (err && err.name === 'TimeoutError') {
                        this.growlService.showErrorGrowl('ERROR.TIMEOUT');
                    }
                    return throwError(err);
                }));
    }
}
